import { PageLayout, getPageStatus } from 'components/PageLayout';
import { AnyGeoEvent } from 'features/geoEvents/anyGeoEvent.types';
import { useGeoEvent } from 'features/geoEvents/hooks/useGeoEvent';
import { Helmet } from 'react-helmet';
import { useAuthState } from 'state/useAuthState';

type GeoEventEditorLayoutProps = {
  id?: string;
  createHelmetTitle: string;
  editHelmetTitle: string;
  renderSuccess: (geoEvent?: AnyGeoEvent) => JSX.Element;
  hasAccess?: boolean; // Allows us to override the access check for those who can not report, like location editors
};

export const GeoEventEditorLayout = (
  props: GeoEventEditorLayoutProps,
): JSX.Element => {
  const {
    id,
    createHelmetTitle,
    editHelmetTitle,
    renderSuccess,
    hasAccess: hasAccessProp,
  } = props;
  const {
    permissions: { canReportWildfire },
  } = useAuthState();
  const {
    geoEvent,
    isGeoEventLoading,
    isGeoEventFetchError,
    geoEventFetchError,
  } = useGeoEvent<AnyGeoEvent>({
    id: id ? Number(id) : undefined,
    useCacheBuster: true,
  });

  const title = geoEvent?.name || (id ? editHelmetTitle : createHelmetTitle);

  const status = getPageStatus({
    isUnauthorized: !(hasAccessProp ?? canReportWildfire),
    isLoading: isGeoEventLoading,
    isError: isGeoEventFetchError,
  });

  return (
    <PageLayout
      data-cname="GeoEventEditorLayout"
      status={status}
      errorMessage={
        geoEventFetchError ? JSON.stringify(geoEventFetchError) : undefined
      }
      headerBarProps={{ title, action: 'back' }}
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {renderSuccess(geoEvent)}
    </PageLayout>
  );
};
